import { authSplitApi } from 'redux/helpers/slice.helpers';
import {
  checklistTemplateConverter,
  checklistTemplateSaveConverter,
} from 'data/converters/checklistTemplate.converters';
import {
  TChecklistTemplate,
  TChecklistTemplateEditUi,
  TChecklistTemplateSaveUi,
  TChecklistTemplateUi,
} from 'data/types/checklistTemplate.types';

export const CHECKLIST_TEMPLATE_URL = 'api/checklist-template';

export const checklistTemplateApi = authSplitApi('checklistTemplateApi', [
  'checklistTemplates',
]).injectEndpoints({
  endpoints: build => ({
    /**
     * Returns every template with its items already ordered, so the ticket-side picker can preview
     * a template's contents without a second request.
     */
    getChecklistTemplates: build.query<TChecklistTemplateUi[], void>({
      query: () => ({
        url: `${CHECKLIST_TEMPLATE_URL}/all`,
        method: 'GET',
      }),
      transformResponse: (data: TChecklistTemplate[]) => {
        return data.map(template =>
          checklistTemplateConverter.fromDb(template),
        );
      },
      providesTags: ['checklistTemplates'],
    }),
    createChecklistTemplate: build.mutation<
      TChecklistTemplate,
      TChecklistTemplateSaveUi
    >({
      query: template => ({
        url: CHECKLIST_TEMPLATE_URL,
        method: 'POST',
        body: checklistTemplateSaveConverter.toDb(template),
      }),
      invalidatesTags: ['checklistTemplates'],
    }),
    /** Full replace of name + items; there is no per-item endpoint. */
    saveChecklistTemplate: build.mutation<
      TChecklistTemplate,
      TChecklistTemplateEditUi
    >({
      query: template => ({
        url: `${CHECKLIST_TEMPLATE_URL}/${template.id}`,
        method: 'PUT',
        body: checklistTemplateSaveConverter.toDb(template),
      }),
      invalidatesTags: ['checklistTemplates'],
    }),
    deleteChecklistTemplate: build.mutation<void, string>({
      query: id => ({
        url: `${CHECKLIST_TEMPLATE_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['checklistTemplates'],
    }),
  }),
});

export const {
  useGetChecklistTemplatesQuery,
  useCreateChecklistTemplateMutation,
  useSaveChecklistTemplateMutation,
  useDeleteChecklistTemplateMutation,
} = checklistTemplateApi;
